import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    DialogActions,
    Button,
    IconButton,
    Tooltip
} from '@mui/material';
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import eyeIcon from '@iconify/icons-mdi/eye-circle-outline';
import printerIcon from '@iconify/icons-mdi/printer-outline';
import trashIcon from '@iconify/icons-mdi/trash-can-outline';
import * as XLSX from "xlsx";
import '../../../styles/Auth/sales.css';
import { getData, postData } from '../../../webService/webservice.js';
import { getParsedPaymentMethods, getPaymentMethodBreakdowns } from '../../../utils/utils.js';
import { API_URL } from "../../../utils/utils.js";
import { formatWhatsAppMessage } from "../../../utils/constants.js";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useStore } from "../../../Context/context.jsx";
import StoreSingleAllStoresSelect, { ALL_STORE_OPTION } from "../../Challange/StoreSingleAllStoresSelect.jsx";
import Footer from "../Footer/Footer-page.jsx";
import CustomerSelect from "../../Challange/CustomerSelect.jsx";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { generateInvoiceHTML as generateDynamicInvoiceHTML } from "../../../utils/invoicePrintTemplates";
dayjs.extend(utc);
const SalesPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const role = localStorage.getItem("role");
    const adminStoreIds = JSON.parse(localStorage.getItem("storeIds") || "[]");
    const initialStoreId = adminStoreIds[0] || "";
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const sessionToken = localStorage.getItem("Token");
    const [limit, setLimit] = useState(5);
    const [invoices, setInvoices] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [openReasonModal, setOpenReasonModal] = useState(false);
    const [cancelReason, setCancelReason] = useState("");
    const [openOtpModal, setOpenOtpModal] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [showDateFilter, setShowDateFilter] = useState(false);
    const [store, setStore] = useState(ALL_STORE_OPTION);
    const [otp, setOtp] = useState('');
    const [currentStore, setCurrentStore] = useState(null);
    const [transactionType, setTransactionType] = useState("ALL");
    const [loadingMessage, setLoadingMessage] = useState("");
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [isViewSalesModalOpen, setIsViewSalesModalOpen] = useState(false);
    const [salesSummaryData, setSalesSummaryData] = useState(null);
    const { selectedStoreId, setSelectedStoreId } = useStore();
    const [refreshKey, setRefreshKey] = useState(0);
    const [sortField, setSortField] = useState("createdAt");
    const [sortOrder, setSortOrder] = useState(-1);
    const [openActionModal, setOpenActionModal] = useState(false);
    const [actionInvoice, setActionInvoice] = useState(null);
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);
    const [viewInvoiceData, setViewInvoiceData] = useState(null);
    const handleClearFilters = () => {
        setSearchQuery("");
        setStartDate("");
        setEndDate("");
        setTransactionType("ALL");
        setSelectedCustomer(null);
        setCurrentPage(1);
    };

    const handleSort = (field) => {
        const newOrder =
            sortField === field ? (sortOrder === 1 ? -1 : 1) : -1;

        setSortField(field);
        setSortOrder(newOrder);
    };
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const isGstVerified = currentStore?.gstData?.status === "VERIFIED";

    const headings = [
        'S.NO',
        'Date',
        'Invoice No',
        'Biller',
        'Customer',
        'Sale Type',
        'Total Product',
        'Total Service',

        'Total Price',
        'Payment Method',
        'Action'
    ];
    const handlePageChange = (direction) => {
        setCurrentPage((prev) => {
            if (direction === "next") return Math.min(prev + 1, totalPages);
            if (direction === "prev") return Math.max(prev - 1, 1);
            if (direction === "first") return 1;
            if (direction === "last") return totalPages;
            return prev;
        });
    };

    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };

    const fetchInvoices = async (page, limit, searchQuery) => {
        const params = {
            page,
            limit: limit === 'all' ? 999999 : limit,
            title: searchQuery?.trim() || "",
            sort: JSON.stringify([[sortField, sortOrder]])
        }
        if (startDate) params.startDate = startDate;
        if (endDate) params.endDate = endDate;
        if (selectedCustomer?.value) params.customerId = selectedCustomer.value;

        if (transactionType && transactionType !== "ALL") {
            params.transactionType = transactionType;
        }

        const sid = ["SuperAdmin", "SelfAdmin", "Manager", "Accountant"].includes(role) ? store?.value : Array.isArray(selectedStoreId)
            ? selectedStoreId[0]
            : selectedStoreId;
        if (sid && sid.length === 24) {
            params.storeId = sid;
        }
        // if (selectedStoreId) params.storeId = selectedStoreId;
        try {
            setLoading(true);
            const response = await getData('invoices/invoices', params, sessionToken);

            if (response?.status !== 200) {
                toast.error(response.message || "Failed to fetch Invoices");
                return;
            }

            const invoices = response?.data?.results || [];
            const totalCount = response?.data?.totalItems || 0;
            const totalPages = response?.data?.totalPages || 1;
            const currentPage = response?.data?.currentPage || 1;

            setInvoices(invoices);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
            setCurrentPage(currentPage);
        } catch (error) {
            toast.error(error.message || "Failed to fetch categories");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const token = localStorage.getItem("Token");
        fetchInvoices(currentPage, limit, searchQuery, token, selectedStoreId);
    }, [currentPage, limit, refreshKey, searchQuery, selectedStoreId, sortField, sortOrder, startDate, endDate, store, transactionType, selectedCustomer]);

    useEffect(() => {
        const fetchStoreDetails = async () => {
            const sid = ["SuperAdmin", "SelfAdmin", "Manager", "Accountant"].includes(role) ? store?.value : (Array.isArray(selectedStoreId) ? selectedStoreId[0] : selectedStoreId);
            if (sid && sid.length === 24) {
                try {
                    const res = await getData(`stores/store/${sid}`, {}, sessionToken);
                    if (res?.data) {
                        setCurrentStore(res.data);
                    }
                } catch (error) {
                    console.error("Store detail fetch failed", error);
                }
            } else {
                setCurrentStore(null);
            }
        };
        fetchStoreDetails();
    }, [selectedStoreId, store, role]);

    const handleViewSalesSummary = async () => {
        // We fetch with limit=all to get the full filtered set for the summary
        const params = {
            page: 1,
            limit: 999999, // fetch all
            title: searchQuery?.trim() || "",
            sort: JSON.stringify([[sortField, sortOrder]])
        }
        if (startDate) params.startDate = startDate;
        if (endDate) params.endDate = endDate;
        if (selectedCustomer?.value) params.customerId = selectedCustomer.value;

        if (transactionType && transactionType !== "ALL") {
            params.transactionType = transactionType;
        }

        const sid = ["SuperAdmin", "SelfAdmin", "Manager", "Accountant"].includes(role) ? store?.value : Array.isArray(selectedStoreId)
            ? selectedStoreId[0]
            : selectedStoreId;
        if (sid && sid.length === 24) {
            params.storeId = sid;
        }

        try {
            setLoading(true);
            const response = await getData('invoices/invoices', params, sessionToken);

            if (response?.status !== 200) {
                toast.error(response.message || "Failed to fetch sales summary");
                return;
            }

            const allInvoices = response?.data?.results || [];

            // Calculate summaries
            const summary = {
                totalInvoices: allInvoices.length,
                totalAmount: allInvoices.reduce((sum, inv) => sum + (inv.finalAmount || 0), 0),
                totalGST: allInvoices.reduce((sum, inv) => sum + (inv.totalGST || 0), 0),
                paymentMethods: {},
                transactionTypes: {},
                allInvoices: allInvoices // Keep for exporting later if needed
            };

            allInvoices.forEach(inv => {
                // Payment Methods logic
                const parsedMethods = getParsedPaymentMethods(inv);
                parsedMethods.forEach(p => {
                    const method = p.method.toUpperCase();
                    summary.paymentMethods[method] = (summary.paymentMethods[method] || 0) + p.amount;
                });

                // Transaction Types logic
                const type = inv.transactionType || "UNKNOWN";
                summary.transactionTypes[type] = (summary.transactionTypes[type] || 0) + 1;
            });

            setSalesSummaryData(summary);
            setIsViewSalesModalOpen(true);
        } catch (error) {
            toast.error(error.message || "An error occurred");
        }
    };

    const loadCustomers = async (search, loadedOptions, { page }) => {
        const token = localStorage.getItem("Token");
        const sid = ["SuperAdmin", "SelfAdmin", "Manager", "Accountant"].includes(role) ? store?.value : (Array.isArray(selectedStoreId) ? selectedStoreId[0] : selectedStoreId);

        try {
            const res = await getData(
                "customers/customers",
                {
                    page,
                    limit: 10,
                    search,
                    storeId: sid
                },
                token
            );

            const pageData = res?.data?.[0];
            const customers = pageData?.paginatedResults || [];

            const options = customers.map((cus) => ({
                value: cus._id,
                label: cus.name,
                phone: cus.phoneNumber,
            }));

            return {
                options,
                hasMore: pageData?.currentPage < pageData?.totalPages,
                additional: { page: page + 1 }
            };
        } catch (error) {
            console.error("Customer fetch failed", error);
            return {
                options: [],
                hasMore: false,
                additional: { page: 1 }
            };
        }
    };

    const downloadInvoicePDF = async (invoice) => {
        try {
            // ✅ Choose the correct HTML template based on invoice status
            const htmlContent =
                invoice.status === "Cancelled"
                    ? generateCancelInvoiceHTML(invoice)
                    : generateInvoiceHTML(invoice);

            // ✅ Create a hidden container for rendering
            const container = document.createElement("div");
            container.style.position = "absolute";
            container.style.left = "-9999px";
            container.style.width = "80mm";
            container.innerHTML = htmlContent;
            document.body.appendChild(container);

            // ✅ Find the .box element inside to render only the content card
            const boxElement = container.querySelector(".box");
            const elementToRender = boxElement || container;

            // ✅ Convert HTML element to Canvas
            const canvas = await html2canvas(elementToRender, {
                scale: 2,
                useCORS: true,
                allowTaint: true
            });
            const imgData = canvas.toDataURL("image/png");

            // ✅ Calculate dynamic height for PDF based on actual content aspect ratio
            const pdfWidth = 80; // Standard receipt width in mm
            const elementWidthInMm = 76; // Match .box width (76mm)
            const imgHeightInMm = (canvas.height * elementWidthInMm) / canvas.width;
            
            // Add top and bottom margins (3mm each)
            const pdfHeight = imgHeightInMm + 6; 

            const pdf = new jsPDF("p", "mm", [pdfWidth, pdfHeight]);
            
            // Center the 76mm rendered content on the 80mm page with 2mm left/right margin and 3mm top/bottom margin
            pdf.addImage(imgData, "PNG", 2, 3, elementWidthInMm, imgHeightInMm);

            // ✅ Smart naming based on status
            const fileName =
                invoice.status === "Cancelled"
                    ? `Cancelled-Invoice-${invoice.invoiceNo}.pdf`
                    : `Invoice-${invoice.invoiceNo}.pdf`;

            pdf.save(fileName);

            document.body.removeChild(container);
            setOpenActionModal(false);
        } catch (err) {
            console.error("PDF generation error:", err);
            toast.error("Failed to generate invoice PDF");
        }
    };

    const [isSendingWhatsApp, setIsSendingWhatsApp] = useState(false);

    const handleShareWhatsApp = async (invoice) => {
        if (!invoice) return;
        if (isSendingWhatsApp) {
            toast.warn("WhatsApp dispatch is already in progress. Please wait.");
            return;
        }

        const customerName = invoice.customerId?.name || "Customer";
        let customerPhone = invoice.customerId?.phoneNumber || "";

        let cleanPhone = customerPhone.replace(/\D/g, "");
        if (cleanPhone.length === 10) {
            cleanPhone = `91${cleanPhone}`;
        }

        const executeDirectMetaSend = async (targetPhone) => {
            setIsSendingWhatsApp(true);
            const toastId = toast.info("Sending bill via WhatsApp...", { autoClose: false });
            try {
                const token = localStorage.getItem("Token");
                const res = await postData(`invoices/${invoice._id}/send-whatsapp`, { customerPhone: targetPhone, customerName }, token);
                toast.dismiss(toastId);

                if (res?.status === 200 && res?.data?.success) {
                    toast.success("Bill sent successfully via WhatsApp.");
                } else {
                    const errMsg = res?.data?.error || res?.data?.message || res?.message || "Failed to send bill via WhatsApp. Please try again.";
                    toast.error(errMsg);
                }
            } catch (err) {
                toast.dismiss(toastId);
                console.error("WhatsApp dispatch error:", err);
                toast.error("Failed to send bill via WhatsApp. Please try again.");
            } finally {
                setIsSendingWhatsApp(false);
            }
        };

        if (cleanPhone && cleanPhone.replace(/\D/g, "").length >= 10) {
            await executeDirectMetaSend(cleanPhone);
        } else {
            Swal.fire({
                title: 'Share via WhatsApp',
                text: 'Enter WhatsApp Phone Number with Country Code (e.g., 919876543210):',
                input: 'text',
                inputValue: cleanPhone || '91',
                showCancelButton: true,
                confirmButtonText: 'Send via WhatsApp',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#25D366',
                inputValidator: (value) => {
                    if (!value || value.replace(/\D/g, "").length < 10) {
                        return 'Please enter a valid phone number with country code (e.g., 919876543210)';
                    }
                }
            }).then(async (result) => {
                if (result.isConfirmed && result.value) {
                    let targetPhone = result.value.replace(/\D/g, "");
                    if (targetPhone.length === 10) targetPhone = `91${targetPhone}`;
                    await executeDirectMetaSend(targetPhone);
                }
            });
        }
    };

    const printInvoicePDF = (invoice) => {
        const html = invoice.status === "Cancelled"
            ? generateCancelInvoiceHTML(invoice)
            : generateDynamicInvoiceHTML(invoice, currentStore);

        const win = window.open("", "_blank");
        win.document.write(html);
        win.document.close();

        // Robust print handling
        win.onload = function () {
            win.focus();
            setTimeout(() => {
                win.print();
                win.close();
            }, 500);
        };

        if (win.document.readyState === "complete") {
            win.focus();
            setTimeout(() => {
                win.print();
                win.close();
            }, 500);
        }
        setOpenActionModal(false);
    };

    const generateInvoiceHTML = (invoice) => {
        if (!invoice) return alert("No invoice found");
        return generateDynamicInvoiceHTML(invoice, currentStore);
    };

    const handleCancelInvoiceClick = (invoice) => {
        if (invoice.status === "Cancelled") {
            toast.info("This invoice has already been cancelled.");
            return;
        }
        setSelectedInvoice(invoice);
        setCancelReason(""); // Reset previous reason
        setOtp(""); // Reset previous OTP
        setOpenReasonModal(true); // Open reason modal first
    };

    const handleReasonSubmit = async (mode) => {

        if (!cancelReason.trim()) {
            toast.error("Please provide a reason");
            return;
        }

        try {

            setLoading(true);

            if (mode === "MAIL_ONLY") {
                setLoadingMessage("Cancelling Invoice...");
            } else {
                setLoadingMessage("Sending OTP...");
            }

            const token = localStorage.getItem("Token");
            const userId = localStorage.getItem("userId");

            const response = await postData(
                "otps/otp/send",
                {
                    invoiceId: selectedInvoice._id,
                    requestedBy: userId,
                    reason: cancelReason,
                    cancelMode: mode
                },
                token
            );

            if (response?.status === 200) {

                if (mode === "MAIL_ONLY") {

                    toast.success(
                        response?.message ||
                        "Invoice cancelled successfully"
                    );

                    setOpenReasonModal(false);

                    fetchInvoices(currentPage, limit, searchQuery);

                } else {

                    toast.success("OTP sent successfully");

                    setOpenReasonModal(false);
                    setOpenOtpModal(true);
                }

            } else {
                toast.error(response?.message || "Failed");
            }

        } catch (error) {

            toast.error(
                error?.response?.data?.message ||
                error?.message ||
                "Something went wrong"
            );

        } finally {

            setLoading(false);
            setLoadingMessage("");
        }
    };


    const handleVerifyOtp = async () => {
        if (!otp.trim()) {
            toast.warn("Please enter OTP");
            return;
        }

        try {
            const token = localStorage.getItem("Token");
            const userId = localStorage.getItem("userId");

            const response = await postData(
                "otps/otp/verify",
                { invoiceId: selectedInvoice._id, otp, requestedBy: userId, reason: cancelReason },
                token
            );

            if (response?.status === 200) {
                toast.success("Invoice cancelled successfully");

                // Optional: print cancelled invoice
                printCancelInvoice(selectedInvoice);

                // Reset
                setOpenOtpModal(false);
                setOtp("");
                setCancelReason("");
                setSelectedInvoice(null);

                // Refresh invoice list
                fetchInvoices(currentPage, limit, searchQuery);
            } else {
                toast.error(response?.message || "Invalid OTP");
            }
        } catch (error) {
            console.error("❌ OTP Verification Error:", error.message);
            toast.error("Failed to verify OTP");
        }
    };

    useEffect(() => {
        const handleStoreChange = () => {
            const storeId = selectedStoreId;
            setSelectedStoreId(storeId);
            setSelectedCustomer(null);
            setCurrentPage(1);
        };

        window.addEventListener("storeChanged", handleStoreChange);
        return () => window.removeEventListener("storeChanged", handleStoreChange);
    }, []);

    const generateCancelInvoiceHTML = (invoice) => {
        if (!invoice) return "";

        /* ---------------- EXTRACT VALUES ---------------- */
        let items = invoice.items || [];
        const grandTotal = Number(invoice.grandTotal || invoice.finalAmount || 0);

        const itemWiseDiscount = items.reduce((sum, item) => sum + Number(item.manualDiscount || item.itemDiscount || item.discount || 0), 0);
        const membershipDiscount = Number(invoice.membershipDiscount || 0);
        const overallDiscount = Number(invoice.overallDiscount || invoice.discount || 0);
        const couponDiscount = Number(invoice.couponDiscount || 0);
        const totalDiscount = itemWiseDiscount + membershipDiscount + overallDiscount + couponDiscount;

        const totalGST = Number(invoice.totalGST || 0);
        const roundOff = Number(invoice.roundOff || 0);
        const billAmount = grandTotal;
        const netAmount = Math.max(0, billAmount - totalGST - roundOff);
        const miscCharges = Number(invoice.miscellaneousCharges || 0);
        const basicSales = netAmount + totalDiscount - miscCharges;

        const storeName = invoice.storeId?.storeName || currentStore?.storeName || "Store";
        const storeAddress = invoice.storeId?.address || currentStore?.address || "";
        const storePhone = invoice.storeId?.phoneNumber || currentStore?.phoneNumber || "";
        const storeGst = invoice.storeId?.gstData?.gstNo || currentStore?.gstData?.gstNo || "";
        const storeLogo = invoice.storeId?.logo || currentStore?.logo || "";

        /* ---------------- HELPERS ---------------- */
        const getItemName = (item) => {
            if (item.serviceId?.serviceName) return item.serviceId.serviceName;
            if (item.productId?.title) return item.productId.title;
            return item.productName || item.serviceName || item.subscriptionName || "Item";
        };

        const generateRows = (list) => {
            return list.map((item) => {
                const name = getItemName(item);
                const qty = Number(item.qty || 1);
                const rate = Number(item.price || 0);
                const itemDiscount = Number(item.manualDiscount || item.itemDiscount || item.discount || item.membershipDiscount || 0);
                const amount = Number(item.total || ((rate * qty) - itemDiscount));
                return `
                    <tr>
                        <td style="padding: 2px 0;">${name}</td>
                        <td align="center">${qty}</td>
                        <td align="right">${rate.toFixed(2)}</td>
                        <td align="right">${amount.toFixed(2)}</td>
                    </tr>
                `;
            }).join("");
        };

        const tenderAmount = Array.isArray(invoice.paymentMode)
            ? invoice.paymentMode.reduce((sum, p) => sum + Number(p.amount || 0), 0)
            : Number(invoice.paymentMode?.amount || grandTotal);
        const changeAmount = Math.max(0, tenderAmount - billAmount);

        const paymentString = (invoice.paymentMode || [])
            .map((p) => `${p.method}=${Number(p.amount || 0).toFixed(0)}`)
            .join(", ");

        const gstSummaryMap = {};
        items.forEach(item => {
            const rate = Number(
                item.gstRate ||
                item.gstPercentage ||
                item.serviceId?.gstPercentage ||
                item.productId?.gstPercentage ||
                item.taxPercentage ||
                item.taxRate ||
                0
            );
            if (rate === 0) return;

            const gstAmt = Number(item.gstAmount || item.taxAmount || 0);
            const halfGst = gstAmt / 2;
            const isProduct = item.category === "product" || !!item.productId;

            if (!gstSummaryMap[rate]) {
                gstSummaryMap[rate] = { cgst: 0, sgst: 0, pcgst: 0, psgst: 0 };
            }
            if (isProduct) {
                gstSummaryMap[rate].pcgst += halfGst;
                gstSummaryMap[rate].psgst += halfGst;
            } else {
                gstSummaryMap[rate].cgst += halfGst;
                gstSummaryMap[rate].sgst += halfGst;
            }
        });

        const gstSummaryRows = Object.keys(gstSummaryMap).sort((a, b) => a - b).map(rate => {
            const data = gstSummaryMap[rate];
            return `
                <tr>
                    <td>${rate}%</td>
                    <td align="right">${data.cgst.toFixed(2)}</td>
                    <td align="right">${data.sgst.toFixed(2)}</td>
                    <td align="right">${data.pcgst.toFixed(2)}</td>
                    <td align="right">${data.psgst.toFixed(2)}</td>
                </tr>
            `;
        }).join("");

        return `
<html>
<head>
    <title>CANCELLED - ${invoice.invoiceNo}</title>
    <style>
        @page {
            size: 80mm auto;
            margin: 0mm;
        }
        html, body {
            width: 80mm;
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
            background: #fff;
            color: #000;
        }
        body {
            display: flex;
            justify-content: center;
        }
        .box {
            width: 76mm;
            padding: 3mm;
            box-sizing: border-box;
            position: relative;
        }
        .cancelled-watermark {
            color: rgba(255, 0, 0, 0.12);
            font-size: 36px;
            font-weight: bold;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(-45deg);
            z-index: 1;
            pointer-events: none;
            white-space: nowrap;
        }
        .center {
            text-align: center;
        }
        .logo {
            width: 100px;
            margin-bottom: 5px;
            opacity: 0.5;
        }
        .store-name {
            font-size: 16px;
            font-weight: 700;
        }
        .tax-title {
            font-size: 18px;
            font-weight: bold;
            margin-top: 4px;
            color: red;
        }
        .divider {
            border-top: 1px dashed #000;
            margin: 5px 0;
        }
        table {
            width: 100%;
            border-collapse: collapse;
            font-size: 11px;
        }
        th {
            text-align: left;
            border-bottom: 1px dashed #000;
            padding: 3px 0;
            font-size: 11px;
        }
        td {
            padding: 2px 0;
            vertical-align: top;
            word-break: break-word;
        }
        .summary-table td {
            padding: 1px 0;
        }
        .bold {
            font-weight: bold;
        }
        .large {
            font-size: 13px;
        }
        .footer {
            text-align: center;
            margin-top: 10px;
            font-size: 10px;
            font-weight: bold;
            line-height: 1.4;
        }
    </style>
</head>
<body>
    <div class="box">
        <div class="cancelled-watermark">CANCELLED</div>
        <div class="center">
            ${storeLogo ? `<img src="${storeLogo}" class="logo" />` : ""}
            <div class="tax-title">CANCELLED INVOICE</div>
            <div class="store-name">${storeName}</div>
            <div style="margin-top:5px;">${storeAddress}</div>
            <div>Ph:- ${storePhone}</div>
            ${storeGst ? `<div>GST No: ${storeGst}</div>` : ""}
        </div>

        <div class="divider"></div>

        <table>
            <tr><td width="35%">InvoiceNo.</td><td>: ${invoice.invoiceNo}</td></tr>
            <tr><td>BillDate</td><td>: ${new Date(invoice.invoiceDate || invoice.createdAt).toLocaleDateString('en-GB')}, ${new Date(invoice.createdAt).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true })}</td></tr>
            <tr><td>CustomerName</td><td>: ${invoice.transactionType === "SELF" ? "Self" : (invoice.customerId?.name || "Walk-in")}</td></tr>
            ${invoice.transactionType !== "SELF" ? `
            <tr><td>CustomerPhone</td><td>: ${invoice.customerId?.phoneNumber || "-"}</td></tr>
            ` : ""}
            <tr><td>Biller</td><td>: ${invoice.billBy?.name || "-"}</td></tr>
        </table>

        <div class="divider"></div>

        <table>
            <thead>
                <tr>
                    <th width="45%">PARTICULARS</th>
                    <th align="center">QTY</th>
                    <th align="right">RATE</th>
                    <th align="right">AMOUNT</th>
                </tr>
            </thead>
            <tbody>
                ${generateRows(items)}
            </tbody>
        </table>

        <div class="divider"></div>

        <table class="summary-table">
            <tr><td>BASIC SALES</td><td align="right">${basicSales.toFixed(2)}</td></tr>
            ${miscCharges > 0 ? `
            <tr><td>MISC CHARGES${invoice.reason ? ` (${invoice.reason})` : ''}</td><td align="right">${miscCharges.toFixed(2)}</td></tr>
            ` : ""}
            ${membershipDiscount > 0 ? `<tr><td>MEM.DISCOUNT</td><td align="right">-${membershipDiscount.toFixed(2)}</td></tr>` : ""}
            ${itemWiseDiscount > 0 ? `<tr><td>ITEM DISCOUNT</td><td align="right">-${itemWiseDiscount.toFixed(2)}</td></tr>` : ""}
            ${couponDiscount > 0 ? `<tr><td>COUPON DISCOUNT</td><td align="right">-${couponDiscount.toFixed(2)}</td></tr>` : ""}
            ${overallDiscount > 0 ? `<tr><td>OVERALL DISCOUNT</td><td align="right">-${overallDiscount.toFixed(2)}</td></tr>` : ""}
            <tr class="bold"><td>NET AMOUNT</td><td align="right">${netAmount.toFixed(2)}</td></tr>
            <tr><td>GST AMOUNT</td><td align="right">${totalGST.toFixed(2)}</td></tr>
            <tr class="bold large"><td>BILL AMOUNT</td><td align="right">${(billAmount + roundOff).toFixed(2)}</td></tr>
            ${tenderAmount > 0 ? `
            <tr><td>TENDER AMOUNT</td><td align="right">${tenderAmount.toFixed(2)}</td></tr>
            <tr><td>CHANGE AMOUNT</td><td align="right">${changeAmount.toFixed(2)}</td></tr>
            ` : ""}
        </table>

        <div class="divider"></div>

        <div class="bold">Cancel Details:</div>
        <div style="margin-top:5px; font-size: 11px;">
            <strong>Reason:</strong> ${invoice.cancelReason || "N/A"}<br/>
            <strong>Payment:</strong> ${paymentString || "-"}
        </div>

        <div class="divider"></div>

        <div class="footer" style="color: red;">
            INVOICE HAS BEEN CANCELLED
        </div>
    </div>
</body>
</html>`;
    };

    const printCancelInvoice = (invoice) => {
        const html = generateCancelInvoiceHTML(invoice);
        const win = window.open("", "_blank");
        win.document.write(html);
        win.document.close();
        win.focus();
        win.print();
        win.close();
    };

    const exportSalesExcel = (data) => {
        const invoices = (data || []).filter(inv => inv.status !== "Cancelled");
        if (!Array.isArray(invoices) || invoices.length === 0) {
            return alert("No active invoice data found!");
        }

        // ========= SHEET 1 - INVOICE SUMMARY =========
        const invoiceRows = invoices.map(inv => {
            const customer = inv.customerId?.name || "WALK-IN";
            const cash = (inv.paymentMode || []).filter(p => p.method?.toUpperCase() === "CASH").reduce((sum, p) => sum + (p.amount || 0), 0);
            const upi = (inv.paymentMode || []).filter(p => ["UPI", "GOOGLE PAY", "PHONEPE", "PAYTM", "ONLINE_PAYMENT"].includes(p.method?.toUpperCase())).reduce((sum, p) => sum + (p.amount || 0), 0);
            const card = (inv.paymentMode || []).filter(p => ["CARD", "CREDIT_CARD", "DEBIT_CARD"].includes(p.method?.toUpperCase())).reduce((sum, p) => sum + (p.amount || 0), 0);
            const other = (inv.paymentMode || []).filter(p => !["CASH", "UPI", "CARD", "CREDIT_CARD", "DEBIT_CARD", "GOOGLE PAY", "PHONEPE", "PAYTM", "ONLINE_PAYMENT"].includes(p.method?.toUpperCase())).reduce((sum, p) => sum + (p.amount || 0), 0);

            return {
                "Invoice No": inv.invoiceNo,
                Date: new Date(inv.invoiceDate || inv.createdAt).toLocaleDateString('en-GB'),
                Store: inv.storeId?.storeName,
                "Txn Type": inv.transactionType,
                Customer: customer,
                "Product Qty": inv.totalProductQty,
                "Service Qty": inv.totalServiceQty,
                ...(isGstVerified ? {
                    "SGST": inv.sgst || (inv.totalGST / 2) || 0,
                    "CGST": inv.cgst || (inv.totalGST / 2) || 0,
                    "Total GST": inv.totalGST || 0
                } : {}),
                "Discount": Number(inv.membershipDiscount || 0) + Number(inv.overallDiscount || inv.discount || 0) + Number(inv.couponDiscount || 0),
                "Cash": cash,
                "UPI": upi,
                "Card": card,
                "Other": other,
                "Final Amount": inv.finalAmount,
                "Billed By": inv.billBy?.name ?? "-"
            };
        });

        const totalSGST = invoices.reduce((s, x) => s + (x.sgst || (x.totalGST / 2) || 0), 0);
        const totalCGST = invoices.reduce((s, x) => s + (x.cgst || (x.totalGST / 2) || 0), 0);
        const totalGST = invoices.reduce((s, x) => s + (x.totalGST || 0), 0);
        const totalDiscount = invoices.reduce((s, x) => s + (Number(x.membershipDiscount || 0) + Number(x.overallDiscount || x.discount || 0) + Number(x.couponDiscount || 0)), 0);
        const totalFinal = invoices.reduce((s, x) => s + (x.finalAmount || 0), 0);

        const totalCash = invoiceRows.reduce((s, x) => s + (x.Cash || 0), 0);
        const totalUPI = invoiceRows.reduce((s, x) => s + (x.UPI || 0), 0);
        const totalCard = invoiceRows.reduce((s, x) => s + (x.Card || 0), 0);
        const totalOther = invoiceRows.reduce((s, x) => s + (x.Other || 0), 0);

        const totalsRow = {
            "Invoice No": "TOTALS",
            "Discount": totalDiscount,
            "Cash": totalCash,
            "UPI": totalUPI,
            "Card": totalCard,
            "Other": totalOther,
            "Final Amount": totalFinal,
        };
        if (isGstVerified) {
            totalsRow["SGST"] = totalSGST;
            totalsRow["CGST"] = totalCGST;
            totalsRow["Total GST"] = totalGST;
        }

        invoiceRows.push(totalsRow);

        const sheet1 = XLSX.utils.json_to_sheet(invoiceRows);

        // ========= SHEET 2 - ITEM-WISE TABLE =========
        const itemRows = [];

        invoices.forEach(inv => {
            inv.items.forEach(it => {
                const name =
                    it.productId?.title ||
                    it.serviceId?.serviceName ||
                    it.subscriptionId?.subscriptionName ||
                    "Item";

                itemRows.push({
                    "Invoice No": inv.invoiceNo,
                    Date: new Date(inv.invoiceDate || inv.createdAt).toLocaleDateString('en-GB'),
                    Item: name,
                    Category: it.category,
                    Qty: it.qty,
                    Rate: it.price,
                    Discount:
                        it.discountType === "PERCENTAGE"
                            ? `${it.discountValue}% `
                            : it.discountValue,
                    ...(isGstVerified ? {
                        "SGST": it.sgst || 0,
                        "CGST": it.cgst || 0,
                        "GST": it.gstAmount || 0
                    } : {}),
                    Total: it.total,
                    Employee: it.billBy ?? "-"
                });
            });
        });

        // Add Total row for Item Sheet
        const itemTotalQty = itemRows.reduce((s, x) => s + (x.Qty || 0), 0);
        const itemTotalValue = itemRows.reduce((s, x) => s + (x.Total || 0), 0);
        const itemTotalSGST = itemRows.reduce((s, x) => s + (x.SGST || 0), 0);
        const itemTotalCGST = itemRows.reduce((s, x) => s + (x.CGST || 0), 0);
        const itemTotalGST = itemRows.reduce((s, x) => s + (x.GST || 0), 0);

        const itemTotalsRow = {
            "Invoice No": "TOTALS",
            Qty: itemTotalQty,
            Total: itemTotalValue
        };
        if (isGstVerified) {
            itemTotalsRow["SGST"] = itemTotalSGST;
            itemTotalsRow["CGST"] = itemTotalCGST;
            itemTotalsRow["GST"] = itemTotalGST;
        }
        itemRows.push(itemTotalsRow);

        const sheet2 = XLSX.utils.json_to_sheet(itemRows);

        // ========= CREATE WORKBOOK =========
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, sheet1, "Invoice Summary");
        XLSX.utils.book_append_sheet(wb, sheet2, "Item Details");

        const filename = `SalesReport - ${Date.now()}.xlsx`;
        XLSX.writeFile(wb, filename);
    };

    return (
        <div className="product-layout">
            <div className="product-content">
                <div className="product-main">
                    <Typography variant="h6" sx={{ mb: 2 }}>
                        Sales
                    </Typography>
                    <div className="product-widgets">
                        {/* <div className="product-widget-header"> */}
                        {/* <input
                                type="text"
                                placeholder="Search"
                                className="Sales-search-input"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            /> */}
                        {["SuperAdmin", "SelfAdmin", "Manager", "Accountant"].includes(role) && (
                            <StoreSingleAllStoresSelect
                                value={store}
                                onChange={
                                    (store) => {
                                        setStore(store);
                                        setSelectedCustomer(null);
                                        setCurrentPage(1);
                                    }
                                }
                            />
                        )}
                        <div className="customer-widgets-header" style={{ display: "flex", justifyContent: "flex-end", width: "100%", gap: "12px" }}>
                            <button
                                className="add-Product-button"
                                onClick={handleViewSalesSummary}
                            >
                                View Sales
                            </button>
                            <button
                                className="add-Product-button"
                                onClick={() => exportSalesExcel(invoices)}
                            >
                                Export Sales
                            </button>
                            <button
                                className="add-Product-button"
                                onClick={() => setShowDateFilter(!showDateFilter)}
                            >
                                {showDateFilter ? "Hide Filter" : "Show Filter"}
                            </button>
                        </div>
                    </div>
                    {showDateFilter && (
                        <div className="sales-filter-container">
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <label style={{ fontSize: "12px", fontWeight: 600, marginBottom: "4px" }}>Start Date</label>
                                <input
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                    style={{
                                        padding: "6px 10px",
                                        width: "150px",
                                        borderRadius: "6px",
                                        border: "1px solid #ccc",
                                        fontSize: "13px"
                                    }}
                                />
                            </div>

                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <label style={{ fontSize: "12px", fontWeight: 600, marginBottom: "4px" }}>End Date</label>
                                <input
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    style={{
                                        padding: "6px 10px",
                                        width: "150px",
                                        borderRadius: "6px",
                                        border: "1px solid #ccc",
                                        fontSize: "13px"
                                    }}
                                />
                            </div>

                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <label style={{ fontSize: "12px", fontWeight: 600, marginBottom: "4px" }}>
                                    Transaction Type
                                </label>
                                <select
                                    value={transactionType}
                                    onChange={(e) => {
                                        setTransactionType(e.target.value);
                                        setCurrentPage(1);
                                    }}
                                    style={{
                                        padding: "6px 10px",
                                        width: "160px",
                                        borderRadius: "6px",
                                        border: "1px solid #ccc",
                                        fontSize: "13px"
                                    }}
                                >
                                    <option value="ALL">All</option>
                                    <option value="SALE">Sale</option>
                                    <option value="SELF">Self</option>
                                    <option value="MEMBERSHIP">Membership</option>
                                </select>
                            </div>

                            <div style={{ display: "flex", flexDirection: "column", width: "200px" }}>
                                <label style={{ fontSize: "12px", fontWeight: 600, marginBottom: "4px" }}>
                                    Customer
                                </label>
                                <CustomerSelect
                                    value={selectedCustomer}
                                    onChange={(val) => {
                                        setSelectedCustomer(val);
                                        setCurrentPage(1);
                                    }}
                                    loadCustomers={loadCustomers}
                                    showAddOption={false}
                                />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <button
                                    className="cancel-Product-button"
                                    onClick={handleClearFilters}
                                    style={{
                                        padding: "6px 12px",
                                        fontSize: "13px",
                                        height: "33px"
                                    }}
                                >
                                    Clear
                                </button>
                            </div>
                        </div>
                    )}
                    <Box component={Paper}>
                        <TableContainer sx={{
                            maxHeight: 400,   // fixed height for table container
                            overflowY: "auto",
                            '&::-webkit-scrollbar': { display: 'none' },
                            scrollbarWidth: 'none',
                            msOverflowStyle: 'none',
                        }}>
                            <Table className="custom-product-table">
                                <TableHead className="custom-product-head">
                                    <TableRow>
                                        {headings.map((heading, index) => {
                                            const isBiller = heading === "Biller";
                                            const isCustomer = heading === "Customer";
                                            const isSaleType = heading === "Sale Type";
                                            const sortKey = isBiller
                                                ? "billBy"
                                                : isCustomer
                                                    ? "customerId"
                                                    : isSaleType
                                                        ? "transactionType"
                                                        : null;
                                            return (
                                                <TableCell
                                                    key={index}
                                                    sx={{
                                                        border: "none",
                                                        padding: "12px 16px",
                                                        textAlign: "center",
                                                        position: "sticky",
                                                        top: 0,
                                                        zIndex: 0,
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            gap: "4px",
                                                            color: "#ffffff",
                                                            fontSize: "14px",
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        {heading}

                                                        {sortKey && (
                                                            <span
                                                                onClick={() => handleSort(sortKey)}
                                                                style={{
                                                                    fontSize: "10px",
                                                                    color: "#ffffffff",
                                                                    cursor: "pointer",
                                                                    marginLeft: "4px",
                                                                    userSelect: "none",
                                                                }}
                                                            >
                                                                {sortField === sortKey
                                                                    ? sortOrder === 1
                                                                        ? "▲"
                                                                        : "▼"
                                                                    : "▲▼"}
                                                            </span>
                                                        )}
                                                    </Typography>
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>

                                </TableHead>
                                <TableBody>
                                    {!invoices || invoices.length === 0 ? (
                                        <TableRow>
                                            <TableCell colSpan={8}>
                                                <Typography
                                                    sx={{
                                                        textAlign: 'center',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        padding: '20px',
                                                        fontWeight: 500
                                                    }}
                                                >
                                                    No Sales found.
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        invoices.map((invoice, index) => (
                                            <TableRow key={invoice._id}>
                                                <TableCell>
                                                    <Typography sx={commonCellStyle}>
                                                        {(currentPage - 1) * (limit === 'all' ? 0 : limit) + index + 1}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography sx={commonCellStyle}>
                                                        {invoice.invoiceDate
                                                            ? dayjs(invoice.invoiceDate).utc().format("DD/MM/YYYY")
                                                            : dayjs(invoice.createdAt).utc().format("DD/MM/YYYY")}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            alignItems: "center",
                                                            gap: "4px"
                                                        }}
                                                    >
                                                        <Typography sx={commonCellStyle}>
                                                            {invoice.invoiceNo}
                                                        </Typography>

                                                        {invoice.status === "Cancelled" ? (
                                                            <Box
                                                                sx={{
                                                                    background: "#ffebee",
                                                                    color: "#ff0000ff",
                                                                    padding: "2px 8px",
                                                                    borderRadius: "12px",
                                                                    fontSize: "10px",
                                                                    fontWeight: 700
                                                                }}
                                                            >
                                                                CANCELLED
                                                            </Box>
                                                        ) : invoice.transactionType === "MEMBERSHIP" ? (
                                                            <Box
                                                                sx={{
                                                                    background: "#f3e5f5",
                                                                    color: "#7b1fa2",
                                                                    padding: "2px 8px",
                                                                    borderRadius: "12px",
                                                                    fontSize: "10px",
                                                                    fontWeight: 700
                                                                }}
                                                            >
                                                                MEMBERSHIP
                                                            </Box>
                                                        ) : invoice.transactionType === "SELF" ? (
                                                            <Box
                                                                sx={{
                                                                    background: "#fff3e0",
                                                                    color: "#ef6c00",
                                                                    padding: "2px 8px",
                                                                    borderRadius: "12px",
                                                                    fontSize: "10px",
                                                                    fontWeight: 700
                                                                }}
                                                            >
                                                                SELF
                                                            </Box>
                                                        ) : (
                                                            <Box
                                                                sx={{
                                                                    background: "#e8f5e9",
                                                                    color: "#28b52fff",
                                                                    padding: "2px 8px",
                                                                    borderRadius: "12px",
                                                                    fontSize: "10px",
                                                                    fontWeight: 700
                                                                }}
                                                            >
                                                                SALE
                                                            </Box>
                                                        )}
                                                    </Box>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography sx={commonCellStyle}>
                                                        {invoice.billBy
                                                            ? `${invoice.billBy.name} (${invoice.billBy.role})`
                                                            : "N/A"}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography sx={commonCellStyle}>
                                                        {invoice.customerId
                                                            ? `${invoice.customerId.name} `
                                                            : "N/A"}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography sx={commonCellStyle}>
                                                        {invoice.transactionType || "N/A"}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography sx={commonCellStyle}>
                                                        {invoice.totalProductQty || 0}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography sx={commonCellStyle}>
                                                        {invoice.totalServiceQty || 0}
                                                    </Typography>
                                                </TableCell>

                                                <TableCell>
                                                    <Typography sx={commonCellStyle}>
                                                        {invoice.grandTotal || 0}
                                                    </Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography sx={commonCellStyle}>
                                                        {getPaymentMethodBreakdowns(invoice).map((breakdown, idx) => (
                                                            <div key={idx}>{breakdown}</div>
                                                        ))}
                                                    </Typography>
                                                </TableCell>

                                                <TableCell>
                                                    <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'center' }}>
                                                        <Tooltip title="View Details" arrow placement="top">
                                                            <Icon
                                                                icon={eyeIcon}
                                                                width={22}
                                                                height={22}
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => {
                                                                    setViewInvoiceData(invoice);
                                                                    setIsViewModalOpen(true);
                                                                }}
                                                            />
                                                        </Tooltip>
                                                        <Tooltip title={invoice?.isCancelled || invoice?.status === "Cancelled" ? "Download Cancel Invoice" : "Print Invoice"} arrow placement="top">
                                                            <Icon
                                                                icon={printerIcon}
                                                                width={22}
                                                                height={22}
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => {
                                                                    setActionInvoice(invoice);
                                                                    setOpenActionModal(true);
                                                                }}
                                                            />
                                                        </Tooltip>
                                                        {role !== "Accountant" && (
                                                            <Tooltip title={invoice?.status === "Cancelled" ? "Already Cancelled" : "Cancel Invoice"} arrow placement="top">
                                                                <Icon
                                                                    icon={trashIcon}
                                                                    width={22}
                                                                    height={22}
                                                                    style={{
                                                                        color: invoice?.status === "Cancelled" ? '#94a3b8' : '#C10000',
                                                                        cursor: invoice?.status === "Cancelled" ? 'not-allowed' : 'pointer',
                                                                        opacity: invoice?.status === "Cancelled" ? 0.5 : 1
                                                                    }}
                                                                    onClick={() => {
                                                                        if (invoice?.status !== "Cancelled") {
                                                                            handleCancelInvoiceClick(invoice);
                                                                        }
                                                                    }}
                                                                />
                                                            </Tooltip>
                                                        )}
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>

                            </Table>
                        </TableContainer>
                        <div className="product-bottom">
                            <div className="product-section show-entries">
                                <span className="text-label">Show</span>
                                <select className="entries-select" value={limit}
                                    onChange={handleItemsPerPageChange}
                                >
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="all">All</option>
                                </select>
                                <span className="text-label">Entries</span>
                            </div>
                            <div className="sales-section showing-range">
                                {
                                    limit === 'all'
                                        ? `Showing all ${totalCount} entries`
                                        : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                }
                            </div>
                            <div className="sales-section spacer"></div>
                            <div className="sales-section pagination-buttons">
                                <button
                                    className="pagination-btn"
                                    disabled={currentPage === 1}
                                    onClick={() => handlePageChange("first")}
                                >
                                    <Icon icon='mdi:chevron-double-left' width={18} height={18} />
                                </button>
                                <button
                                    className="pagination-btn"
                                    disabled={currentPage === 1}
                                    onClick={() => handlePageChange("prev")}
                                >
                                    <Icon icon='mdi:chevron-left' width={18} height={18} />
                                </button>
                                <button
                                    className="pagination-btn"
                                    disabled={currentPage === totalPages}
                                    onClick={() => handlePageChange("next")}
                                >
                                    <Icon icon='mdi:chevron-right' width={18} height={18} />
                                </button>
                                <button
                                    className="pagination-btn"
                                    disabled={currentPage === totalPages}
                                    onClick={() => handlePageChange("last")}
                                >
                                    <Icon icon='mdi:chevron-double-right' width={18} height={18} />
                                </button>
                            </div>
                        </div>
                    </Box>
                    <Dialog open={openOtpModal} onClose={() => setOpenOtpModal(false)} maxWidth="sm" fullWidth>
                        <DialogTitle style={{ backgroundColor: '#f7f7f7', fontWeight: 600, textAlign: 'center' }}>Verify OTP</DialogTitle>
                        <DialogContent style={{ display: 'flex', flexDirection: 'column', gap: '12px', padding: '24px' }}>
                            <input
                                type="text"
                                placeholder="Enter OTP"
                                value={otp}
                                onChange={(e) => setOtp(e.target.value)}
                                style={{
                                    width: '100%',
                                    padding: '10px',
                                    borderRadius: '8px',
                                    border: '1px solid #ccc',
                                    fontSize: '14px'
                                }}
                            />
                        </DialogContent>
                        <DialogActions>
                            <button className="cancel-Product-button" onClick={() => setOpenOtpModal(false)}>Cancel</button>
                            <button className="add-Product-button" onClick={handleVerifyOtp} variant="contained">Verify & Cancel</button>
                        </DialogActions>
                    </Dialog>


                    <Dialog open={openReasonModal} onClose={() => setOpenReasonModal(false)} maxWidth="sm" fullWidth>
                        <DialogTitle style={{ backgroundColor: '#f7f7f7', fontWeight: 600, textAlign: 'center' }}>Reason for Cancellation</DialogTitle>
                        <DialogContent style={{ display: 'flex', flexDirection: 'column', gap: '12px', padding: '24px' }}>
                            <textarea
                                rows={5}
                                placeholder="Enter reason"
                                value={cancelReason}
                                onChange={(e) => setCancelReason(e.target.value)}
                                style={{
                                    width: '95%',
                                    padding: '10px',
                                    borderRadius: '8px',
                                    border: '1px solid #ccc',
                                    fontSize: '14px',
                                    resize: 'none'
                                }}
                            />
                            {loading && (
                                <div style={{
                                    textAlign: 'center',
                                    color: '#300008',
                                    fontWeight: 600
                                }}>
                                    {loadingMessage}
                                </div>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                variant="outlined"
                                disabled={loading}
                                onClick={() => handleReasonSubmit("MAIL_ONLY")}
                            >
                                Mail Only Cancel
                            </Button>

                            <Button
                                variant="contained"
                                disabled={loading}
                                onClick={() => handleReasonSubmit("OTP")}
                            >
                                Send OTP
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={isViewSalesModalOpen}
                        onClose={() => setIsViewSalesModalOpen(false)}
                        maxWidth="md"
                        fullWidth
                        PaperProps={{
                            sx: {
                                borderRadius: '16px',
                                padding: '10px'
                            }
                        }}
                    >
                        <DialogTitle sx={{
                            borderBottom: '1px solid #efefef',
                            mb: 2,
                            fontWeight: 700,
                            color: '#1a1a1a',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            Sales Summary Preview
                            <Typography variant="body2" color="textSecondary">
                                {startDate && endDate ? `${startDate} to ${endDate}` : "Full History"}
                            </Typography>
                        </DialogTitle>
                        <DialogContent>
                            {salesSummaryData && (
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                                    {/* Top Level Stats */}
                                    <Box sx={{
                                        display: 'grid',
                                        gridTemplateColumns: { xs: '1fr 1fr', sm: '1fr 1fr 1fr' },
                                        gap: 2
                                    }}>
                                        <Box sx={{ p: 2, bgcolor: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                                            <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 600, textTransform: 'uppercase' }}>Total Invoices</Typography>
                                            <Typography variant="h5" sx={{ fontWeight: 700, color: '#0f172a' }}>{salesSummaryData.totalInvoices}</Typography>
                                        </Box>
                                        <Box sx={{ p: 2, bgcolor: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                                            <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 600, textTransform: 'uppercase' }}>Total Revenue</Typography>
                                            <Typography variant="h5" sx={{ fontWeight: 700, color: '#10b981' }}>{salesSummaryData.totalAmount.toLocaleString()}</Typography>
                                        </Box>
                                        <Box sx={{ p: 2, bgcolor: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                                            <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 600, textTransform: 'uppercase' }}>Total GST</Typography>
                                            <Typography variant="h5" sx={{ fontWeight: 700, color: '#f59e0b' }}>{salesSummaryData.totalGST.toLocaleString()}</Typography>
                                        </Box>
                                    </Box>

                                    {/* Breakdown Sections */}
                                    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 3 }}>
                                        {/* Payment Methods */}
                                        <Box>
                                            <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 700, color: '#475569', display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <Icon icon="mdi:credit-card-outline" /> Payment Breakdown
                                            </Typography>
                                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                                {Object.entries(salesSummaryData.paymentMethods).map(([method, amount]) => (
                                                    <Box key={method} sx={{ display: 'flex', justifyContent: 'space-between', p: 1.5, bgcolor: '#fff', border: '1px solid #f1f5f9', borderRadius: '8px' }}>
                                                        <Typography variant="body2" sx={{ fontWeight: 600 }}>{method}</Typography>
                                                        {method !== 'SERVICE WALLET' && (
                                                            <Typography variant="body2" sx={{ fontWeight: 700 }}>{amount.toLocaleString()}</Typography>
                                                        )}
                                                    </Box>
                                                ))}
                                            </Box>
                                        </Box>

                                        {/* Transaction Types */}
                                        <Box>
                                            <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 700, color: '#475569', display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <Icon icon="mdi:swap-horizontal" /> Transaction Types
                                            </Typography>
                                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                                {Object.entries(salesSummaryData.transactionTypes).map(([type, count]) => (
                                                    <Box key={type} sx={{ display: 'flex', justifyContent: 'space-between', p: 1.5, bgcolor: '#fff', border: '1px solid #f1f5f9', borderRadius: '8px' }}>
                                                        <Typography variant="body2" sx={{ fontWeight: 600 }}>{type}</Typography>
                                                        <Typography variant="body2" sx={{ fontWeight: 700 }}>{count} Invoices</Typography>
                                                    </Box>
                                                ))}
                                            </Box>
                                        </Box>
                                    </Box>

                                    {/* All Invoices in Selection Table */}
                                    <Box>
                                        <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 700, color: '#475569' }}>
                                            Invoices in Selection
                                        </Typography>
                                        <TableContainer sx={{ border: '1px solid #f1f5f9', borderRadius: '8px', maxHeight: '300px', overflowY: 'auto' }}>
                                            <Table size="small" stickyHeader>
                                                <TableHead sx={{ bgcolor: '#3C0008' }}>
                                                    <TableRow>
                                                        <TableCell sx={{ fontWeight: 700, fontSize: '12px', bgcolor: '#3C0008', color: '#ffffff' }}>Date</TableCell>
                                                        <TableCell sx={{ fontWeight: 700, fontSize: '12px', bgcolor: '#3C0008', color: '#ffffff' }}>Invoice</TableCell>
                                                        <TableCell sx={{ fontWeight: 700, fontSize: '12px', bgcolor: '#3C0008', color: '#ffffff' }}>Customer</TableCell>
                                                        <TableCell sx={{ fontWeight: 700, fontSize: '12px', bgcolor: '#3C0008', color: '#ffffff' }} align="right">Amount</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {salesSummaryData.allInvoices.map((inv) => (
                                                        <TableRow key={inv._id} hover>
                                                            <TableCell sx={{ fontSize: '12px' }}>
                                                                {new Date(inv.invoiceDate || inv.createdAt).toLocaleDateString('en-GB')}
                                                            </TableCell>
                                                            <TableCell sx={{ fontSize: '12px' }}>{inv.invoiceNo}</TableCell>
                                                            <TableCell sx={{ fontSize: '12px' }}>{inv.customerId?.name || "Walk-in"}</TableCell>
                                                            <TableCell sx={{ fontSize: '12px' }} align="right">{(inv.finalAmount || 0).toLocaleString()}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Box>

                                </Box>
                            )}
                        </DialogContent>
                        <DialogActions sx={{ p: 3, borderTop: '1px solid #efefef' }}>
                            <button className="cancel-Product-button" onClick={() => setIsViewSalesModalOpen(false)}>
                                Close
                            </button>
                            <button className="add-Product-button" onClick={() => {
                                exportSalesExcel(salesSummaryData.allInvoices);
                                setIsViewSalesModalOpen(false);
                            }}>
                                <Icon icon="mdi:file-excel" style={{ marginRight: '8px' }} />
                                Download Full Report
                            </button>
                        </DialogActions>
                    </Dialog>

                    {/* Print or Download selection modal */}
                    <Dialog
                        open={openActionModal}
                        onClose={() => setOpenActionModal(false)}
                        maxWidth="xs"
                        fullWidth
                        PaperProps={{
                            sx: { borderRadius: '12px', p: 1 }
                        }}
                    >
                        <DialogTitle sx={{ textAlign: 'center', fontWeight: 700, pb: 1 }}>
                            Invoice Options
                        </DialogTitle>
                        <DialogContent>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                                <Button
                                    variant="outlined"
                                    fullWidth
                                    startIcon={<Icon icon="mdi:eye" />}
                                    onClick={() => {
                                        setViewInvoiceData(actionInvoice);
                                        setIsViewModalOpen(true);
                                        setOpenActionModal(false);
                                    }}
                                    sx={{
                                        py: 1.5,
                                        borderRadius: '8px',
                                        color: '#3C0008',
                                        borderColor: '#3C0008',
                                        '&:hover': {
                                            borderColor: '#3C0008',
                                            bgcolor: 'rgba(60, 0, 8, 0.04)'
                                        }
                                    }}
                                >
                                    View Details
                                </Button>
                                <Button
                                    variant="outlined"
                                    fullWidth
                                    startIcon={<Icon icon="mdi:printer" />}
                                    onClick={() => printInvoicePDF(actionInvoice)}
                                    sx={{
                                        py: 1.5,
                                        borderRadius: '8px',
                                        color: '#3C0008',
                                        borderColor: '#3C0008',
                                        '&:hover': {
                                            borderColor: '#3C0008',
                                            bgcolor: 'rgba(60, 0, 8, 0.04)'
                                        }
                                    }}
                                >
                                    Print Invoice
                                </Button>
                                <Button
                                    variant="contained"
                                    fullWidth
                                    startIcon={<Icon icon="mdi:download" />}
                                    onClick={() => downloadInvoicePDF(actionInvoice)}
                                    sx={{
                                        py: 1.5,
                                        borderRadius: '8px',
                                        bgcolor: '#3C0008',
                                        '&:hover': { bgcolor: '#2A0006' }
                                    }}
                                >
                                    Download PDF
                                </Button>
                                {/* Temporarily Hidden Share via WhatsApp
                                <Button
                                    variant="contained"
                                    fullWidth
                                    startIcon={<Icon icon="mdi:whatsapp" />}
                                    onClick={() => {
                                        handleShareWhatsApp(actionInvoice);
                                        setOpenActionModal(false);
                                     }}
                                    sx={{
                                        py: 1.5,
                                        borderRadius: '8px',
                                        bgcolor: '#25D366',
                                        color: 'white',
                                        '&:hover': { bgcolor: '#128C7E' }
                                    }}
                                >
                                    Share via WhatsApp
                                </Button>
                                */}
                            </Box>
                        </DialogContent>
                        <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
                            <Button onClick={() => setOpenActionModal(false)} sx={{ color: '#666' }}>
                                Cancel
                            </Button>
                        </DialogActions>
                    </Dialog>

                    {/* View Invoice Modal */}
                    <Dialog
                        open={isViewModalOpen}
                        onClose={() => setIsViewModalOpen(false)}
                        maxWidth="md"
                        fullWidth
                        PaperProps={{
                            sx: { borderRadius: '16px', overflow: 'hidden' }
                        }}
                    >
                        <DialogTitle sx={{
                            bgcolor: '#3C0008',
                            color: 'white',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            p: 2
                        }}>
                            <Typography variant="h6" fontWeight={700}>
                                Invoice Details - {viewInvoiceData?.invoiceNo}
                            </Typography>
                            <Icon
                                icon="mdi:close"
                                style={{ cursor: 'pointer', fontSize: '24px' }}
                                onClick={() => setIsViewModalOpen(false)}
                            />
                        </DialogTitle>
                        <DialogContent sx={{ p: 0 }}>
                            {viewInvoiceData && (
                                <Box sx={{ p: 3 }}>
                                    {/* Header Info */}
                                    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 4, mb: 4 }}>
                                        <Box>
                                            <Typography variant="subtitle2" color="text.secondary" gutterBottom>Store Information</Typography>
                                            <Typography variant="body1" fontWeight={600}>{viewInvoiceData.storeId?.storeName || currentStore?.storeName}</Typography>
                                            <Typography variant="body2" color="text.secondary">{currentStore?.address}</Typography>
                                            <Typography variant="body2" color="text.secondary">Phone: {currentStore?.phoneNumber}</Typography>
                                            {currentStore?.gstData?.gstNo && (
                                                <Typography variant="body2" color="text.secondary">GST: {currentStore.gstData.gstNo}</Typography>
                                            )}
                                        </Box>
                                        <Box sx={{ textAlign: { xs: 'left', md: 'right' } }}>
                                            <Typography variant="subtitle2" color="text.secondary" gutterBottom>Customer Information</Typography>
                                            <Typography variant="body1" fontWeight={600}>{viewInvoiceData.customerId?.name || "Walk-in"}</Typography>
                                            <Typography variant="body2" color="text.secondary">{viewInvoiceData.customerId?.phoneNumber || "-"}</Typography>
                                            <Box sx={{ mt: 2 }}>
                                                <Typography variant="body2">Date: {new Date(viewInvoiceData.invoiceDate || viewInvoiceData.createdAt).toLocaleDateString('en-GB')}, {new Date(viewInvoiceData.createdAt).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true })}</Typography>
                                                <Typography variant="body2" sx={{
                                                    color: viewInvoiceData.status === "Cancelled" ? "error.main" : "success.main",
                                                    fontWeight: 700
                                                }}>
                                                    Status: {viewInvoiceData.status || "Completed"}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>

                                    {/* Items Table */}
                                    <TableContainer component={Paper} variant="outlined" sx={{ mb: 4, borderRadius: '8px' }}>
                                        <Table size="small">
                                            <TableHead sx={{ bgcolor: '#3C0008' }}>
                                                <TableRow>
                                                    <TableCell sx={{ fontWeight: 700, color: "white" }}>Item</TableCell>
                                                    <TableCell sx={{ fontWeight: 700, color: "white" }}>Staff</TableCell>
                                                    <TableCell align="center" sx={{ fontWeight: 700, color: "white" }}>Qty</TableCell>
                                                    <TableCell align="right" sx={{ fontWeight: 700, color: "white" }}>Rate</TableCell>
                                                    <TableCell align="right" sx={{ fontWeight: 700, color: "white" }}>Disc</TableCell>
                                                    <TableCell align="right" sx={{ fontWeight: 700, color: "white" }}>Amount</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {viewInvoiceData.items?.map((item, idx) => {
                                                    const name = item.serviceId?.serviceName || item.productId?.title || item.subscriptionId?.subscriptionName || item.productName || item.serviceName || item.subscriptionName || "Item";
                                                    const qty = Number(item.qty || 1);
                                                    const rate = Number(item.price || 0);
                                                    const itemDiscount = Number(item.manualDiscount || item.itemDiscount || item.discount || item.membershipDiscount || 0);
                                                    const amount = Number(item.total || ((rate * qty) - itemDiscount));
                                                    return (
                                                        <TableRow key={idx}>
                                                            <TableCell>{name}</TableCell>
                                                            <TableCell>
                                                                {(() => {
                                                                    if (Array.isArray(item.employeeIds) && item.employeeIds.length > 0) {
                                                                        return item.employeeIds.map(emp => {
                                                                            if (typeof emp === 'object' && emp !== null) {
                                                                                return emp.name || `${emp.firstName || ""} ${emp.lastName || ""}`.trim() || emp.username || emp.employeeName;
                                                                            }
                                                                            return emp;
                                                                        }).filter(Boolean).join(", ");
                                                                    }
                                                                    return item.employeeId?.name || "-";
                                                                })()}
                                                            </TableCell>
                                                            <TableCell align="center">{qty}</TableCell>
                                                            <TableCell align="right">{rate.toFixed(2)}</TableCell>
                                                            <TableCell align="right">{itemDiscount.toFixed(2)}</TableCell>
                                                            <TableCell align="right">{amount.toFixed(2)}</TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                    {/* Summary & Taxes */}
                                    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 4 }}>
                                        <Box>
                                            <Typography variant="subtitle2" color="text.secondary" gutterBottom>Payment Summary</Typography>
                                            <Table size="small">
                                                <TableBody>
                                                    {getParsedPaymentMethods(viewInvoiceData).map((p, idx) => (
                                                        <TableRow key={idx}>
                                                            <TableCell sx={{ border: 0, p: 0.5 }}>
                                                                {p.method}
                                                                {p.cardNumber && ` (**** ${p.cardNumber})`}
                                                            </TableCell>
                                                            <TableCell align="right" sx={{ border: 0, p: 0.5 }}>
                                                                {p.method !== 'SERVICE WALLET' ? Number(p.amount || 0).toFixed(2) : ""}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </Box>
                                        <Box>
                                            <Typography variant="subtitle2" color="text.secondary" gutterBottom>Billing Summary</Typography>
                                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                                    {(() => {
                                                        const itemDiscountTotal = viewInvoiceData.items?.reduce((sum, item) => sum + Number(item.manualDiscount || item.itemDiscount || item.discount || 0), 0) || 0;
                                                        const membershipDiscount = Number(viewInvoiceData.membershipDiscount || viewInvoiceData.membershipDiscountAmount || 0);
                                                        const overallDiscount = Number(viewInvoiceData.overallDiscount || viewInvoiceData.overallDiscountAmount || 0);
                                                        const couponDiscount = Number(viewInvoiceData.couponDiscount || viewInvoiceData.couponDiscountAmount || 0);
                                                        const totalDiscounts = itemDiscountTotal + membershipDiscount + overallDiscount + couponDiscount;
                                                        const totalGST = Number(viewInvoiceData.totalGST || 0);
                                                        const roundOff = Number(viewInvoiceData.roundOff || 0);
                                                        const grandTotal = Number(viewInvoiceData.grandTotal || viewInvoiceData.finalAmount || 0);
                                                        const netAmount = grandTotal - totalGST - roundOff;
                                                        const miscellaneousCharges = Number(viewInvoiceData.miscellaneousCharges || 0);
                                                        const basicSales = netAmount + totalDiscounts - miscellaneousCharges;
                                                        const tenderAmount = Array.isArray(viewInvoiceData.paymentMode)
                                                            ? viewInvoiceData.paymentMode.reduce((sum, p) => sum + Number(p.amount || 0), 0)
                                                            : Number(viewInvoiceData.paymentMode?.amount || grandTotal);
                                                        const changeAmount = Math.max(0, tenderAmount - grandTotal);

                                                        return (
                                                            <>
                                                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                    <Typography variant="body2">BASIC SALES:</Typography>
                                                                    <Typography variant="body2">{basicSales.toFixed(2)}</Typography>
                                                                </Box>
                                                                {miscellaneousCharges > 0 && (
                                                                    <>
                                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                            <Typography variant="body2">MISC CHARGES:</Typography>
                                                                            <Typography variant="body2">{miscellaneousCharges.toFixed(2)}</Typography>
                                                                        </Box>
                                                                        {viewInvoiceData.reason && (
                                                                            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                                <Typography variant="caption" sx={{ color: 'text.secondary', pl: 2 }}>
                                                                                    Reason: {viewInvoiceData.reason}
                                                                                </Typography>
                                                                            </Box>
                                                                        )}
                                                                    </>
                                                                )}
                                                                {itemDiscountTotal > 0 && (
                                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                        <Typography variant="body2">ITEM DISCOUNT:</Typography>
                                                                        <Typography variant="body2" color="error">-{itemDiscountTotal.toFixed(2)}</Typography>
                                                                    </Box>
                                                                )}
                                                                {membershipDiscount > 0 && (
                                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                        <Typography variant="body2">MEMBERSHIP DISCOUNT:</Typography>
                                                                        <Typography variant="body2" color="error">-{membershipDiscount.toFixed(2)}</Typography>
                                                                    </Box>
                                                                )}
                                                                {couponDiscount > 0 && (
                                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                        <Typography variant="body2">COUPON DISCOUNT:</Typography>
                                                                        <Typography variant="body2" color="error">-{couponDiscount.toFixed(2)}</Typography>
                                                                    </Box>
                                                                )}
                                                                {overallDiscount > 0 && (
                                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                        <Typography variant="body2">OVERALL DISCOUNT:</Typography>
                                                                        <Typography variant="body2" color="error">-{overallDiscount.toFixed(2)}</Typography>
                                                                    </Box>
                                                                )}
                                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px dashed #eee', pt: 0.5 }}>
                                                                    <Typography variant="body2" fontWeight={700}>NET AMOUNT:</Typography>
                                                                    <Typography variant="body2" fontWeight={700}>{netAmount.toFixed(2)}</Typography>
                                                                </Box>
                                                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                    <Typography variant="body2">GST AMOUNT:</Typography>
                                                                    <Typography variant="body2">{totalGST.toFixed(2)}</Typography>
                                                                </Box>
                                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #3C0008', pt: 0.5 }}>
                                                                    <Typography variant="body1" fontWeight={700}>BILL AMOUNT:</Typography>
                                                                    <Typography variant="body1" fontWeight={700}>{grandTotal.toFixed(2)}</Typography>
                                                                </Box>
                                                                {tenderAmount > 0 && (
                                                                    <>
                                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                            <Typography variant="body2">TENDER AMOUNT:</Typography>
                                                                            <Typography variant="body2">{Number(tenderAmount).toFixed(2)}</Typography>
                                                                        </Box>
                                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                            <Typography variant="body2">CHANGE AMOUNT:</Typography>
                                                                            <Typography variant="body2">{changeAmount.toFixed(2)}</Typography>
                                                                        </Box>
                                                                    </>
                                                                )}
                                                            </>
                                                        );
                                                    })()}
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            )}
                        </DialogContent>
                        <DialogActions sx={{ p: 2, borderTop: '1px solid #eee' }}>
                            <Button onClick={() => setIsViewModalOpen(false)} sx={{ color: '#666' }}>Close</Button>
                            <Button
                                variant="contained"
                                onClick={() => printInvoicePDF(viewInvoiceData)}
                                sx={{ bgcolor: '#3C0008', '&:hover': { bgcolor: '#2A0006' } }}
                            >
                                Print Invoice
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <Footer />
            </div>
        </div>
    );
};

export default SalesPage;
